import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

// Handles direct-to-S3 uploads for logo and watermark forms.
// Expects:
// - controller on the <form> element
// - data-direct-upload-sign-path-value: URL to POST for presigned S3 fields
// - optional data-direct-upload-kind-value: "logo" | "watermark" (for messages)
// - a file input inside the form with data-action="change->direct-upload#fileSelected"
// - an element with id="progress" (shared existing progress bar) for visual feedback
export default class extends Controller {
  static values = {
    signPath: String,
    kind: { type: String, default: "file" }
  }

  fileSelected(event) {
    const input = event.target
    const file = input.files && input.files[0]
    if (!file) return

    const form = this.element
    const signUrl = this.signPathValue

    if (!signUrl) {
      console.error("[direct-upload] Missing signPathValue on form")
      this.showError()
      return
    }

    // Step 1: get S3 presigned fields from Rails
    $.ajax({
      url: signUrl,
      type: "POST",
      data: { file: file.name },
      dataType: "json"
    })
      .done((response) => {
        const signedData = response && response.signed_data
        if (!signedData) {
          console.error("[direct-upload] Missing signed_data in response")
          this.showError()
          return
        }

        // Fill hidden S3 fields
        Object.keys(signedData).forEach((key) => {
          const value = signedData[key]
          const field = form.querySelector(`input[name="${key}"]`)
          if (field) field.value = value
        })

        // Step 2: build FormData for direct S3 upload
        const formData = new FormData()

        // Append all non-file fields from the form
        Array.from(form.elements).forEach((el) => {
          if (!el.name) return
          if (el.type === "file") return
          formData.append(el.name, el.value)
        })

        // Attach the actual file
        formData.append("file", file)

        // Step 3: upload to S3 with progress
        const xhr = new XMLHttpRequest()
        xhr.open("POST", form.action, true)

        xhr.upload.addEventListener("progress", (event) => {
          if (!event.lengthComputable) return

          const percent = Math.round((event.loaded / event.total) * 100)

          // Hide current image if present
          const currentImage = document.querySelector("#current_image")
          if (currentImage) currentImage.style.display = "none"

          // Update shared progress bar (existing element)
          const progress = document.querySelector("#progress")
          if (progress) {
            progress.style.display = "block"
            progress.style.width = `${percent * 0.75}%`
          }
        })

        xhr.onerror = () => {
          console.error("[direct-upload] XHR error")
          this.showError()
        }

        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            // Reload page/frame to show new logo / watermark
            window.location.reload()
          } else {
            console.error("[direct-upload] Upload failed with status", xhr.status)
            this.showError()
          }
        }

        xhr.send(formData)
      })
      .fail(() => {
        console.error("[direct-upload] Signing request failed")
        this.showError()
      })
  }

  showError() {
    // Keep it simple and non-intrusive; re-use existing layout if needed later.
    alert(`Error uploading your ${this.kindValue}. Please try again.`)
  }
}

